import React from 'react';
import PropTypes from 'prop-types';
import PolygonVectorLayer from '../../shared/ui/GeoMap/PolygonVectorLayer';
import GeoMapWithTiles from '../../features/geo-map/GeoMapWithTiles';
import { getGeoZoneViewColors } from '../../shared/geo-map/geoZoneColors';
import style from './GeoZonesMapWidget.module.css';

// Отображает карту с полигоном геозоны
function GeoZonesMapWidget(props) {
  const { isCreatePolygon, geoZones, setCoordsGeoZone, changeableGeoZone } = props;
  const isChangeable = geoZones.length === 1;

  return (
    <GeoMapWithTiles styles={style.geoMap} isOffButtonFollowMode>
      {geoZones?.length > 0 &&
        geoZones.map((geoZone) => {
          // Пользовательские цвета геозоны из атрибутов KML (view.line-color / view.background-color).
          // При их отсутствии PolygonVectorLayer применит цвета по умолчанию.
          const { strokeColor, fillColor } = getGeoZoneViewColors(geoZone);
          return (
            <PolygonVectorLayer
              isSelectable={isChangeable}
              isChangeable={isChangeable}
              setCoordsGeoZone={setCoordsGeoZone}
              isCreatePolygon={isCreatePolygon}
              zIndex={2}
              coordinates={geoZone?.polygon}
              strokeColor={strokeColor}
              fillColor={fillColor}
            />
          );
        })}

      {isCreatePolygon && (
        <PolygonVectorLayer
          isSelectable
          isChangeable
          setCoordsGeoZone={setCoordsGeoZone}
          isCreatePolygon={isCreatePolygon}
          zIndex={2}
          coordinates={changeableGeoZone?.polygon}
        />
      )}
    </GeoMapWithTiles>
  );
}

GeoZonesMapWidget.propTypes = {
  changeableGeoZone: PropTypes.shape(),
  isCreatePolygon: PropTypes.bool.isRequired,
  geoZones: PropTypes.arrayOf(PropTypes.shape()),
  setCoordsGeoZone: PropTypes.func.isRequired,
};

GeoZonesMapWidget.defaultProps = {
  changeableGeoZone: null,
  geoZones: [],
};

export default GeoZonesMapWidget;
